import React from "react";
import styled from "@emotion/styled";
import { Stack, SxProps, Theme, Typography, useTheme } from "@mui/material";

const StyledTitle = styled(Stack) <{ bgColor: string }>`
  flex-shrink: 0;
  width: fit-content;
  background-color: ${({ bgColor }) => bgColor};
  position: relative;
  top: auto;
  height: 68px;
  box-sizing: border-box;
  padding-top: 17px;
  border-radius: 0 0 26px 26px;
`;

const Title = styled(Typography)`
  border-top: 1px dashed #fff;
  height: 35px;
  display: flex;
  justify-content: center;
  padding: 11px 24px;
  text-align: center;
  color: #fff;
`;

export interface LayoutHeaderTitleProps {
  children?: React.ReactNode;
  titleComponent?: React.ReactNode;
  sx?: SxProps<Theme>
}

const LayoutHeaderTitle = ({ children, titleComponent, sx }: LayoutHeaderTitleProps): JSX.Element => {
  const theme = useTheme();

  if (titleComponent) {
    return <>{titleComponent}</>;
  }

  return (
    <StyledTitle bgColor={theme.palette.secondary.main} sx={sx}>
      {typeof children === "string" ? <Title variant="h1">{children}</Title> : children}
    </StyledTitle>
  );
};

export default LayoutHeaderTitle;
